













































































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";

@Component({
  components: {
    "program-level": ProgramLevel,
  },
})
export default class Attendance extends Vue {
  private service = new GeneralService();
  private auth = new AuthService();
  private monthData: any = [];
  private detailData: any = [];
  private username = this.auth.session.userName.split("@")[0];
  private isCalendar = false;
  private queryMonth = 0;
  private queryYear = 2020;
  private currentMonth = '';
  private monthAttendanceData: any = [];
  private monthLoading = true;
  private updateAttrs: number = 0;

  private attrs: any = [];
  private months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  private initializeCalendar(monthString: string) {
    let month = monthString.split("-")[1];
    let year = monthString.split("-")[2];

    this.queryMonth = this.getMonth(month);
    this.queryYear = parseInt(year);

    this.isCalendar = true;
  }

  async monthClicked(monthString: string) {
    this.monthLoading = true;
    // this.disableNav(false);
    let month = monthString.split("-")[1];
    let year = monthString.split("-")[2];
    let nextMonth = this.getNextMonth(month);

    let monthStringQuery = "01-" + month + "-" + year;
    let nextMonthStringQuery = "01-" + nextMonth + "-" + year;

    if (nextMonth == "Jan") {
      nextMonthStringQuery =
        "01-" + nextMonth + "-" + (parseInt(year) + 1).toString();
    }

    this.service
      .getAttendanceDetailEMS(
        this.username,
        monthStringQuery,
        nextMonthStringQuery
      )
      .then((result) => {
        this.detailData = result.data;
        this.queryMonth = this.getMonth(month);
        this.queryYear = parseInt(year);
        this.monthLoading = false;
        // this.disableNav(true);
        this.service.getAttendanceMonth(this.username, monthStringQuery).then((result) => {
          this.monthAttendanceData = result.data[0];
          this.monthLoading = false;
          this.parseData();
        })
      });
  }

  private backMonth(){

  }

  private disableNav(val) {
    let el = document.getElementsByClassName("vc-arrows-container")[0];

    if (el) {
      if (!val) {
        (el as any).style.visibility = "hidden";
      } else {
        (el as any).style.visibility = "visible";
      }
    } else {
    }
  }

  pushBack() {
    this.$router.push("selectCMS");
  }

  changeMonth(page) {
    if (this.updateAttrs == 0){
    let monthString = "01-" + this.months[page.month - 1] + "-" + page.year;
    if (this.currentMonth !== monthString) {
      this.currentMonth = monthString;
      this.monthClicked(monthString);
    }
    } else {
      this.updateAttrs--;
    }
  }

  parseData() {
    let tempattrs: any = [];
    for (let i = 0; i < this.detailData.length; i++) {
      let detail = JSON.parse(this.detailData[i].detail);
      let absent = 0;
      let present = 0;
      let label = "";
      for (let j = 0; j < detail.length; j++) {
        tempattrs.push({
          dot: detail[j].Status == "Absent" ? "red" : (detail[j].Status == "Present" ? "blue" : "gray"),
          dates: new Date(this.detailData[i].dated),
          popover: {
            label: detail[j].Course + ": " + detail[j].Status,
            visibility: "focus",
          },
        });
      }
    }
    this.updateAttrs = 2;
    this.attrs = tempattrs;
  }

  getMonth(month: string) {
    switch (month) {
      case "Jan":
        return 0;
        break;
      case "Feb":
        return 1;
        break;
      case "Mar":
        return 2;
        break;
      case "Apr":
        return 3;
        break;
      case "May":
        return 4;
        break;
      case "Jun":
        return 5;
        break;
      case "Jul":
        return 6;
        break;
      case "Aug":
        return 7;
        break;
      case "Sep":
        return 8;
        break;
      case "Oct":
        return 9;
        break;
      case "Nov":
        return 10;
        break;
      case "Dec":
        return 11;
        break;
      default:
        return 0;
    }
  }

  getNextMonth(month: string) {
    switch (month) {
      case "Jan":
        return "Feb";
        break;
      case "Feb":
        return "Mar";
        break;
      case "Mar":
        return "Apr";
        break;
      case "Apr":
        return "May";
        break;
      case "May":
        return "Jun";
        break;
      case "Jun":
        return "Jul";
        break;
      case "Jul":
        return "Aug";
        break;
      case "Aug":
        return "Sep";
        break;
      case "Sep":
        return "Oct";
        break;
      case "Oct":
        return "Nov";
        break;
      case "Nov":
        return "Dec";
        break;
      case "Dec":
        return "Jan";
        break;
      default:
        return "Err";
    }
  }

  mounted() {
    this.service
      .getAttendanceEMS(this.username, localStorage[config.userInfoEMS])
      .then((result) => {
        this.monthData = result.data.Data;
        this.currentMonth = this.monthData[0].Month;
        this.initializeCalendar(this.monthData[0].Month);
        this.monthClicked(this.monthData[0].Month);
      });
  }
}
